// Bloom wordmark — vector approximation of the PNG mockup until the client
// supplies a final logo. Swap the SVG below and the rest of the app is fine.

import { cn } from "./cn.ts";

export interface BloomLogoProps extends React.SVGProps<SVGSVGElement> {
  variant?: "wordmark" | "icon";
}

export function BloomLogo({ className, variant = "wordmark", ...rest }: BloomLogoProps) {
  if (variant === "icon") {
    return (
      <svg viewBox="0 0 64 64" className={cn("h-8 w-8", className)} aria-label="Bloom" {...rest}>
        <circle cx="32" cy="32" r="30" fill="currentColor" />
        <text
          x="32"
          y="42"
          textAnchor="middle"
          fontFamily="Anton, 'Archivo Black', sans-serif"
          fontSize="32"
          fontWeight="900"
          fill="white"
        >
          B
        </text>
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 220 64" className={cn("h-8 w-auto", className)} aria-label="Bloom" {...rest}>
      <text
        x="0"
        y="50"
        fontFamily="Anton, 'Archivo Black', sans-serif"
        fontSize="56"
        fontWeight="900"
        letterSpacing="-2"
        fill="currentColor"
      >
        BL
        <tspan fontSize="40" dy="-2">
          o
        </tspan>
        <tspan fontSize="56" dy="2">
          OM
        </tspan>
      </text>
    </svg>
  );
}
